import { http } from "services/http";

import type {
  GeneralSettingsResponse,
  GeneralSettingsUpdateRequest,
  GeneralSettingsUpdateResponse,
  SettingsIdRequest,
} from "models/settings.model";

export const settingsApi = {
  generalSettings: () => http.quiet().post<GeneralSettingsResponse>("/api/get-settings"),
  // The api docs name it set-setting; the backend has always answered on set-settings.
  generalSettingsUpdate: (data: GeneralSettingsUpdateRequest) =>
    http.quiet().post<GeneralSettingsUpdateResponse>("/api/set-settings", { ...data }),
  bonusRemove: (data: SettingsIdRequest) => http.quiet().post("/api/bonus-remove", { ...data }),
  rankRemove: (data: SettingsIdRequest) => http.quiet().post("/api/rank-remove", { ...data }),
};
